import { render } from "./faqComponent.vue?vue&type=template&id=66f433de"
import script from "./faqComponent.vue?vue&type=script&lang=js"
export * from "./faqComponent.vue?vue&type=script&lang=js"

import "./faqComponent.vue?vue&type=style&index=0&id=66f433de&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__